import React, { useState, useEffect, useRef, useCallback } from 'react'
import $ from 'jquery'

// Matrix Requirements: [SatCloud_Portal/SDS-93] List Orgs

// ── Standard dropdown (regular users) ────────────────────────────────────────

function OrgStandardDropdown({ user, organization, organizations, handleOrganization }) {
  if (!user.id) return <li></li>;

  var title = organization.name || 'Select Organization';

  return (
    <li className='nav-item dropdown'>
      <a className='nav-link dropdown-toggle'
        href='null'
        role="button"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false">
        {title}
      </a>
      <div className='dropdown-menu'>
        {organizations.map(function(org) {
          return (
            <button
              key={org.id}
              className='dropdown-item'
              onClick={() => handleOrganization(org)}
            >
              {org.name}
            </button>
          );
        })}
      </div>
    </li>
  );
}

// ── Search dropdown (super users) ─────────────────────────────────────────────

function OrgSearchDropdown({ user, organization, handleOrganization }) {
  const [searchValue, setSearchValue] = useState('');
  const [results, setResults]         = useState([]);
  const [isOpen, setIsOpen]           = useState(false);
  const debounceRef  = useRef(null);
  const dropdownRef  = useRef(null);
  const inputRef     = useRef(null);

  const fetchOrgs = useCallback(function(query) {
    var url = query
      ? '/organizations?search=' + encodeURIComponent(query) + '&limit=20'
      : '/organizations?limit=10';
    $.get(url).done(function(data) {
      setResults(data.rows || []);
    });
  }, []);

  // Load initial list when dropdown first opens
  useEffect(function() {
    if (isOpen) {
      fetchOrgs(searchValue);
      // Small delay so the dropdown is in the DOM before focusing
      var t = setTimeout(function() {
        if (inputRef.current) inputRef.current.focus();
      }, 50);
      return function() { clearTimeout(t); };
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  // Debounce search queries while open
  useEffect(function() {
    if (!isOpen) return;
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(function() {
      fetchOrgs(searchValue);
    }, 300);
    return function() { clearTimeout(debounceRef.current); };
  }, [searchValue, fetchOrgs, isOpen]);

  // Close when clicking outside the dropdown
  useEffect(function() {
    function handleOutsideClick(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleOutsideClick);
    return function() { document.removeEventListener('mousedown', handleOutsideClick); };
  }, []);

  function handleSelect(org) {
    handleOrganization(org);
    setIsOpen(false);
    setSearchValue('');
  }

  function handleToggle(e) {
    e.preventDefault();
    setIsOpen(function(prev) { return !prev; });
  }

  if (!user.id) return <li></li>;

  var title = organization.name || 'Select Organization';

  return (
    <li className='nav-item dropdown' ref={dropdownRef}>
      <a className='nav-link dropdown-toggle'
        href='null'
        role="button"
        aria-haspopup="true"
        aria-expanded={isOpen}
        onClick={handleToggle}>
        {title}
      </a>
      {isOpen && (
        <div className='dropdown-menu show' style={{ minWidth: 260 }}>
          <div className='px-2 pt-2 pb-1'>
            <input
              ref={inputRef}
              type='text'
              className='form-control form-control-sm'
              placeholder='Search organizations…'
              value={searchValue}
              onChange={function(e) { setSearchValue(e.target.value); }}
            />
          </div>
          {results.map(function(org) {
            return (
              <button
                key={org.id}
                className='dropdown-item'
                onClick={function() { handleSelect(org); }}
              >
                {org.name}
              </button>
            );
          })}
          {results.length === 0 && (
            <span className='dropdown-item disabled text-muted' style={{ pointerEvents: 'none' }}>
              No organizations found
            </span>
          )}
        </div>
      )}
    </li>
  );
}

// ── Entry point ───────────────────────────────────────────────────────────────

function OrganizationDropdown(props) {
  if (props.user.super === true) {
    return <OrgSearchDropdown {...props} />;
  }
  return <OrgStandardDropdown {...props} />;
}

export default OrganizationDropdown
